// this.$store.state.rutograma
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
  orderBy,
} from "firebase/firestore";
import localforage from "localforage";
import moment from "moment";
import { colecciones } from "../constantes";

// RUTOGRAMA
export const rutograma = {
  registro: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idEmpresa: "",
          nombre: "",
          puntosCriticos: [],
          ubicacion: {
            departamentos: [],
            ciudades: [],
          },
          condicionesPrincipalesRuta: {
            fecha: "",
            horarioMovilizacion: "",
            puntoInicio: {
              coordenadas: {
                latitud: "",
                longitud: "",
                precision: "",
              },
            },
            puntoLlegada: {
              coordenadas: {
                latitud: "",
                longitud: "",
                precision: "",
              },
            },
            distancia: "",
            tiempoEstimado: "",
            materialVia: "Asfalto",
            estadoGeneralVia: "Bueno",
            estadoGeneralViaObservaciones: "",
            cicloruta: "Si",
          },
          vehiculoAMovilizar: {
            tipoVehiculo: "",
            inspeccionPreoperacional: "",
            personalAMovilizar: "",
          },
          reconocimientoDeCentrosDeAtencion: {
            clinicasHospitales: [],
            redApoyoGruposDeSocorroMecanicoAutomotriz: [],
            lineasEmergencia: [
              {
                nombre: "LÍNEA ÚNICA DE ATENCIÓN DE EMERGENCIAS",
                telefono: 123,
              },
              {
                nombre: "POLICIA TRÁNSITO",
                telefono: "#767",
              },
            ],
            estrategiasPrevencionRiesgo: [
              "El conductor no podrá realizar el viaje si se encuentra bajo efecto de alcohol, droga o fármaco.",
              "Para validar la informacion de estado de la via el conductor debera realizar la consulta en https://www.invias.gov.co/ -reporte vias.",
              "El conductor pondrá en practica sus conocimientos en conducción preventiva y segura, mantendrá la calma ante circunstancias del trafico y será ejemplo de la cultura cívica promovida.",
            ],
          },
          registro: {
            idUsuario: "",
            estado: "Creado",
            filtro: {
              fecha: moment().format("YYYY-MM-DD"),
              hora: moment().format("hh:mm:ss A"),
            },
            ubicacion: {
              tokens: [],
            },
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            sincronizacion: serverTimestamp(),
          },
        };
      }
    },
    funciones: {
      async crear(rutograma, modoSinConexion, coleccion) {
        if (modoSinConexion) {
          const obtenerRegistros = await localforage.getItem(
            coleccion
              ? coleccion
              : colecciones.localforage.rutogramas.registros,
          );
          const copia = obtenerRegistros
            ? JSON.parse(JSON.stringify(obtenerRegistros))
            : [];
          const registros = obtenerRegistros
            ? copia.concat([rutograma])
            : [rutograma];
          await localforage.setItem(
            coleccion
              ? coleccion
              : colecciones.localforage.rutogramas.registros,
            registros,
          );
        } else {
          await setDoc(
            doc(
              db,
              coleccion
                ? coleccion
                : colecciones.firebase.rutogramas.registros,
              rutograma.id,
            ),
            rutograma,
          );
        }
      },
      async actualizar(rutograma, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.rutogramas.registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === rutograma.id)
            : -1;
          if (index !== -1) {
            registros[index] = rutograma;
            await localforage.setItem(
              colecciones.localforage.rutogramas.registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(
              db,
              colecciones.firebase.rutogramas.registros,
              rutograma.id,
            ),
            {
              nombre: rutograma.nombre,
              ubicacion: rutograma.ubicacion,
              puntosCriticos: rutograma.puntosCriticos,
              condicionesPrincipalesRuta:
                rutograma.condicionesPrincipalesRuta,
              vehiculoAMovilizar: rutograma.vehiculoAMovilizar,
              reconocimientoDeCentrosDeAtencion:
                rutograma.reconocimientoDeCentrosDeAtencion,
              "registro.ubicacion.tokens":
                rutograma.registro.ubicacion.tokens,
              "registro.estado": "Editado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        }
      },
      async eliminar(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.rutogramas.registros,
          );
          const index = registros
            ? registros.findIndex((reg) => reg.id === id)
            : -1;
          if (index !== -1) {
            registros.splice(index, 1);
            await localforage.setItem(
              colecciones.localforage.rutogramas.registros,
              registros,
            );
          }
        } else {
          await updateDoc(
            doc(db, colecciones.firebase.rutogramas.registros, id),
            {
              "registro.estado": "Eliminado",
              "registro.actualizacion": serverTimestamp(),
            },
          );
        }
      },
      async generarID() {
        const refRutograma = doc(
          collection(db, colecciones.firebase.rutogramas.registros),
        );
        return refRutograma.id;
      },
      async obtener(id, modoSinConexion) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            colecciones.localforage.rutogramas.registros,
          );
          return registros
            ? registros.find((item) => item.id === id)
            : null;
        } else {
          const q = query(
            collection(db, colecciones.firebase.rutogramas.registros),
            where("id", "==", id),
            where("registro.estado", "in", ["Creado", "Editado"]),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs[0].data()
            : null;
        }
      },
      async obtenerRegistros(
        modoSinConexion,
        idEmpresa,
        idUsuario,
        coleccion,
      ) {
        if (modoSinConexion) {
          const registros = await localforage.getItem(
            coleccion
              ? coleccion
              : colecciones.localforage.rutogramas.registros,
          );
          return registros
            ? registros.filter(
              (item) =>
                item.idEmpresa === idEmpresa &&
                item.registro.idUsuario == idUsuario,
            )
            : [];
        } else {
          const q = query(
            collection(
              db,
              coleccion
                ? coleccion
                : colecciones.firebase.rutogramas.registros,
            ),
            where("idEmpresa", "==", idEmpresa),
            where("registro.idUsuario", "==", idUsuario),
            where("registro.estado", "in", ["Creado", "Editado"]),
            orderBy("registro.creacion", "asc"),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.length > 0
            ? querySnapshot.docs.map((doc) => doc.data())
            : null;
        }
      },
      descargarExcelIndividual(item) {
        /* INICIALIZAR LA LIBRERIA */
        const XLSX = require("sheetjs-style");

        /* DEFINICIÓN DE ESTILOS */
        const Styles = {
          title: {
            font: { bold: true, sz: 16 },
            alignment: { horizontal: "center", vertical: "center" },
          },
          greenHeader: {
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
            fill: { fgColor: { rgb: "073d7a" } },
            alignment: { horizontal: "center", vertical: "center" },
          },
          label: {
            font: { bold: true },
            alignment: { horizontal: "left", vertical: "center" },
          },
          grayHeader: {
            font: { bold: true },
            fill: { fgColor: { rgb: "FFBFBFBF" } },
            alignment: { horizontal: "left", vertical: "center" },
          },
          graySubHeader: {
            font: { bold: true },
            fill: { fgColor: { rgb: "FFBFBFBF" } },
            alignment: { horizontal: "center", vertical: "center" },
          },
          cellText: {
            font: { bold: false },
            alignment: {
              horizontal: "left",
              vertical: "center",
              wrapText: true,
            },
          },
          cellLeft: {
            font: { bold: false },
            alignment: {
              horizontal: "left",
              vertical: "center",
              wrapText: true,
            },
          },
          cellCenter: {
            font: { bold: false },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrapText: true,
            },
          },
          border: {
            border: {
              top: { style: "thin", color: { auto: 1 } },
              bottom: { style: "thin", color: { auto: 1 } },
              left: { style: "thin", color: { auto: 1 } },
              right: { style: "thin", color: { auto: 1 } },
            },
          },
          link: {
            font: { color: { rgb: "FF0000FF" }, underline: true },
          },
        };

        /* MAPEADO DE INFORMACIÓN */
        const punto_inicio = `${item.condicionesPrincipalesRuta.puntoInicio.coordenadas.latitud}, ${item.condicionesPrincipalesRuta.puntoInicio.coordenadas.longitud}`;
        const punto_llegada = `${item.condicionesPrincipalesRuta.puntoLlegada.coordenadas.latitud}, ${item.condicionesPrincipalesRuta.puntoLlegada.coordenadas.longitud}`;
        const rutograma = {
          nombre: item.nombre,
          fecha: moment(item.condicionesPrincipalesRuta.fecha).format(
            "DD/MM/YYYY",
          ),
          punto_inicio: `${item.condicionesPrincipalesRuta.puntoInicio.coordenadas
            .latitud &&
            item.condicionesPrincipalesRuta.puntoInicio.coordenadas.longitud
            ? punto_inicio
            : "-"
            }`,
          punto_llegada: `${item.condicionesPrincipalesRuta.puntoLlegada.coordenadas
            .latitud &&
            item.condicionesPrincipalesRuta.puntoInicio.coordenadas.latitud
            ? punto_llegada
            : "-"
            }`,
          departamentos: `${item.ubicacion.departamentos.length > 0
            ? item.ubicacion.departamentos
              .map((departamento) => `${departamento}`)
              .join(", ")
            : "-"
            }`,
          ciudades: `${item.ubicacion.ciudades.length > 0
            ? item.ubicacion.ciudades
              .map((ciudad) => `${ciudad}`)
              .join(", ")
            : "-"
            }`,
          distancia: `${item.condicionesPrincipalesRuta.distancia
            ? item.condicionesPrincipalesRuta.distancia
            : "0"
            } km`,
          tiempo_estimado: `${item.condicionesPrincipalesRuta.tiempoEstimado
            ? item.condicionesPrincipalesRuta.tiempoEstimado
            : "0"
            } minutos`,
          material_via: item.condicionesPrincipalesRuta.materialVia,
          estado_via: item.condicionesPrincipalesRuta.estadoGeneralVia,
          observaciones_estado_via: item.condicionesPrincipalesRuta
            .estadoGeneralViaObservaciones
            ? item.condicionesPrincipalesRuta.estadoGeneralViaObservaciones
            : "-",
          cicloruta: item.condicionesPrincipalesRuta.cicloruta,
          tipo_vehiculo: item.vehiculoAMovilizar.tipoVehiculo
            ? item.vehiculoAMovilizar.tipoVehiculo
            : "-",
          inspeccion_preoperacional: item.vehiculoAMovilizar
            .inspeccionPreoperacional
            ? item.vehiculoAMovilizar.inspeccionPreoperacional
            : "-",
          personal_movilizar: item.vehiculoAMovilizar.personalAMovilizar
            ? item.vehiculoAMovilizar.personalAMovilizar
            : "-",
          puntos_criticos: item.puntosCriticos.map((puntoCritico) => {
            return {
              direccion: puntoCritico.direccion,
              peligros: puntoCritico.peligrosIdentificados,
              medidas: puntoCritico.medidasPrevencion,
              coordenadas: `${puntoCritico.coordenadas.latitud}, ${puntoCritico.coordenadas.longitud}`,
              fotos: puntoCritico.fotos,
            };
          }),
          clinicas_hospitales:
            item.reconocimientoDeCentrosDeAtencion.clinicasHospitales,
          red_apoyo:
            item.reconocimientoDeCentrosDeAtencion
              .redApoyoGruposDeSocorroMecanicoAutomotriz,
          lineas_emergencia:
            item.reconocimientoDeCentrosDeAtencion.lineasEmergencia.map(
              (linea) => {
                return {
                  nombre: linea.nombre,
                  telefono: linea.telefono,
                };
              },
            ),
          estrategias_prevencion:
            item.reconocimientoDeCentrosDeAtencion
              .estrategiasPrevencionRiesgo,
        };

        /* CONSTRUCCIÓN DE DATOS DINAMICOS */
        const sheetData = [];
        const merges = [];
        const styleMap = {};

        /* FUNCIÓN PARA AGREGAR UNA FILA */
        function pushRow(row, mergeToCol = null, style = null) {
          const rowIndex = sheetData.length;
          sheetData.push(row);
          if (mergeToCol !== null) {
            merges.push({
              s: { r: rowIndex, c: 0 },
              e: { r: rowIndex, c: mergeToCol },
            });
          }
          if (style) {
            styleMap[rowIndex] = style;
          }
          return rowIndex;
        }

        /* FUNCIÓN PARA AGREGAR INFORMACIÓN A UNA FILA */
        function addDataRow(label, value) {
          let cellValue = value;
          if (
            (label === "PUNTO DE INICIO" || label === "PUNTO DE LLEGADA") &&
            cellValue !== "-"
          ) {
            const url = `https://www.google.com/maps?q=${value}`;
            cellValue = { t: "s", v: value, l: { Target: url } };
            styleMap[`value_${sheetData.length}`] = "link";
          } else {
            styleMap[`value_${sheetData.length}`] = "cellText";
          }
          const rowIndex = pushRow([label, cellValue, "", "", ""]);
          merges.push({
            s: { r: rowIndex, c: 1 },
            e: { r: rowIndex, c: 4 },
          });
          styleMap[`label_${rowIndex}`] = "grayHeader";
          return rowIndex;
        }

        /* CONDICIONES PRINCIPALES DE LA RUTA */
        pushRow(["RUTOGRAMA", "", "", "", ""], 4, "title");
        pushRow(
          ["CONDICIONES PRINCIPALES DE LA RUTA", "", "", "", ""],
          4,
          "greenHeader",
        );
        addDataRow("NOMBRE", rutograma.nombre);
        addDataRow("FECHA", rutograma.fecha);
        addDataRow("PUNTO DE INICIO", rutograma.punto_inicio);
        addDataRow("PUNTO DE LLEGADA", rutograma.punto_llegada);
        addDataRow("DEPARTAMENTOS", rutograma.departamentos);
        addDataRow("CIUDADES", rutograma.ciudades);
        addDataRow("DISTANCIA", rutograma.distancia);
        addDataRow("TIEMPO ESTIMADO (MINUTOS)", rutograma.tiempo_estimado);
        addDataRow("MATERIAL DE LA VÍA", rutograma.material_via);
        addDataRow("ESTADO GENERAL DE LA VÍA", rutograma.estado_via);
        addDataRow(
          "OBSERVACIONES (ESTADO GENERAL DE LA VÍA)",
          rutograma.observaciones_estado_via,
        );
        addDataRow("CICLORUTA:", rutograma.cicloruta);
        pushRow(["VEHÍCULO A MOVILIZAR", "", "", "", ""], 4, "greenHeader");
        addDataRow("TIPO DE VEHÍCULO", rutograma.tipo_vehiculo);
        addDataRow(
          "INSPECCIÓN PRE-OPERACIONAL",
          rutograma.inspeccion_preoperacional,
        );
        addDataRow("PERSONAL A MOVILIZAR", rutograma.personal_movilizar);

        /* PUNTOS CRITICOS */
        pushRow(["PUNTOS CRÍTICOS", "", "", "", ""], 4, "greenHeader");
        const headerPC = pushRow([
          "DIRECCIÓN",
          "PELIGROS IDENTIFICADOS",
          "MEDIDAS DE PREVENCIÓN",
          "COORDENADAS",
          "FOTOS",
        ]);
        styleMap[headerPC] = "graySubHeader";
        if (
          rutograma.puntos_criticos &&
          rutograma.puntos_criticos.length > 0
        ) {
          rutograma.puntos_criticos.forEach((p) => {
            const coordUrl = `https://www.google.com/maps?q=${p.coordenadas}`;
            const rowIndex = sheetData.length;
            let fotosCell;
            if (Array.isArray(p.fotos) && p.fotos.length > 0) {
              const fotosList = p.fotos
                .map((url, index) => `• Foto #${index + 1}`)
                .join("\n");
              fotosCell = {
                t: "s",
                v: fotosList,
                l: { Target: p.fotos[0] },
              };
            } else {
              fotosCell = "-";
            }
            sheetData.push([
              p.direccion,
              p.peligros,
              p.medidas,
              {
                t: "s",
                v: p.coordenadas,
                l: { Target: coordUrl },
              },
              fotosCell,
            ]);
            styleMap[`${rowIndex}_0`] = "cellCenter";
            styleMap[`${rowIndex}_1`] = "cellLeft";
            styleMap[`${rowIndex}_2`] = "cellLeft";
            styleMap[rowIndex] = "cellCenter";
          });
        } else {
          pushRow(["", "", "", "", ""], 4, "cellText");
        }

        /* RECONOCIMIENTO DE CENTROS DE ATENCIÓN */
        pushRow(
          ["RECONOCIMIENTO DE CENTROS DE ATENCIÓN", "", "", "", ""],
          4,
          "graySubHeader",
        );

        /* CLINICAS Y HOSPITALES */
        pushRow(
          ["CLÍNICAS Y HOSPITALES", "", "", "", ""],
          4,
          "greenHeader",
        );
        if (
          rutograma.clinicas_hospitales &&
          rutograma.clinicas_hospitales.length > 0
        ) {
          rutograma.clinicas_hospitales.forEach((c) => {
            pushRow([c, "", "", "", ""], 4, "cellText");
          });
        } else {
          pushRow(["", "", "", "", ""], 4, "cellText");
        }

        /* RED DE APOYO */
        pushRow(
          [
            "RED DE APOYO GRUPOS DE SOCORRO MECÁNICO AUTOMOTRIZ",
            "",
            "",
            "",
            "",
          ],
          4,
          "greenHeader",
        );
        if (rutograma.red_apoyo && rutograma.red_apoyo.length > 0) {
          rutograma.red_apoyo.forEach((r) => {
            pushRow([r, "", "", "", ""], 4, "cellText");
          });
        } else {
          pushRow(["", "", "", "", ""], 4, "cellText");
        }

        /* LINEAS */
        pushRow(["LÍNEAS DE EMERGENCIA", "", "", "", ""], 4, "greenHeader");
        const lineHeaderIndex = pushRow(["NOMBRE", "", "", "TELÉFONO", ""]);
        styleMap[lineHeaderIndex] = "graySubHeader";
        merges.push({
          s: { r: lineHeaderIndex, c: 0 },
          e: { r: lineHeaderIndex, c: 2 },
        });
        merges.push({
          s: { r: lineHeaderIndex, c: 3 },
          e: { r: lineHeaderIndex, c: 4 },
        });
        if (
          rutograma.lineas_emergencia &&
          rutograma.lineas_emergencia.length > 0
        ) {
          rutograma.lineas_emergencia.forEach((e) => {
            const rowIndex = pushRow([e.nombre, "", "", e.telefono, ""]);
            merges.push({
              s: { r: rowIndex, c: 0 },
              e: { r: rowIndex, c: 2 },
            });
            merges.push({
              s: { r: rowIndex, c: 3 },
              e: { r: rowIndex, c: 4 },
            });
            styleMap[`${rowIndex}_0`] = "cellLeft";
            styleMap[`${rowIndex}_3`] = "cellCenter";
            styleMap[rowIndex] = "cellCenter";
          });
        } else {
          pushRow(["", "", "", "", ""], 4, "cellText");
        }

        /* ESTRATEGIAS */
        pushRow(
          ["ESTRATEGIAS DE PREVENCIÓN DEL RIESGO", "", "", "", ""],
          4,
          "greenHeader",
        );
        if (
          rutograma.estrategias_prevencion &&
          rutograma.estrategias_prevencion.length > 0
        ) {
          rutograma.estrategias_prevencion.forEach((e) => {
            pushRow([e, "", "", "", ""], 4, "cellText");
          });
        } else {
          pushRow(["", "", "", "", ""], 4, "cellText");
        }

        /* AÑADIR CABECERAS E INFORMACIÓN A LA HOJA */
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        ws["!merges"] = merges;

        /* APLICAR ESTILOS DINAMICOS */
        sheetData.forEach((row, r) => {
          row.forEach((_, c) => {
            const cellRef = XLSX.utils.encode_cell({ r, c });
            const specificKey = `${r}_${c}`;
            if (!ws[cellRef]) ws[cellRef] = { t: "s", v: "" };
            ws[cellRef].s = { ...Styles.border };
            if (ws[cellRef].l && c === 3) {
              ws[cellRef].s = {
                ...ws[cellRef].s,
                ...Styles.link,
                alignment: {
                  horizontal: "center",
                  vertical: "center",
                  wrapText: true,
                },
              };
            } else if (ws[cellRef].l && c === 4) {
              ws[cellRef].s = {
                ...ws[cellRef].s,
                ...Styles.link,
                alignment: {
                  wrapText: true,
                  horizontal: "center",
                  vertical: "center",
                  // eslint-disable-next-line no-dupe-keys -- repetido con el mismo valor; no cambia nada
                  wrapText: true,
                },
              };
              return;
            } else if (
              // eslint-disable-next-line no-prototype-builtins -- styleMap es un objeto literal
              styleMap.hasOwnProperty(specificKey) &&
              Styles[styleMap[specificKey]]
            ) {
              ws[cellRef].s = {
                ...ws[cellRef].s,
                ...Styles[styleMap[specificKey]],
              };
            } else {
              const labelKey = styleMap[`label_${r}`];
              const valueKey = styleMap[`value_${r}`];
              const styleKey = styleMap[r];
              if (c === 0 && labelKey && Styles[labelKey]) {
                ws[cellRef].s = { ...ws[cellRef].s, ...Styles[labelKey] };
              }
              if (c === 1 && valueKey && Styles[valueKey]) {
                ws[cellRef].s = { ...ws[cellRef].s, ...Styles[valueKey] };
              }
              if (!labelKey && !valueKey && styleKey && Styles[styleKey]) {
                ws[cellRef].s = { ...ws[cellRef].s, ...Styles[styleKey] };
              }
            }
          });
        });

        /* DEFINIR ANCHO DE LAS COLUMNAS */
        ws["!cols"] = [
          { wch: 50 },
          { wch: 50 },
          { wch: 50 },
          { wch: 25 },
          { wch: 25 },
        ];

        /* GENERAR ARCHIVO */
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Rutograma");
        XLSX.writeFile(wb, `Rutograma de ${rutograma.nombre}.xlsx`);
      },
    },
  },
  puntoCritico: {
    objeto: class {
      constructor() {
        return {
          direccion: "",
          peligrosIdentificados: "",
          medidasPrevencion: "",
          coordenadas: {
            latitud: "",
            longitud: "",
            precision: "",
          },
          fotos: [],
        };
      }
    },
  },
  lineaEmergencia: {
    objeto: class {
      constructor() {
        return {
          nombre: "",
          telefono: "",
        };
      }
    },
  },
};
